function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M74.342 71.9345C71.6504 71.4216 69.8 68.9328 70.0841 66.2076L73.4766 33.6602C73.7974 30.5824 76.6869 28.441 79.7248 29.0297L104.432 33.8177C107.444 34.4013 109.324 37.4221 108.517 40.3816L99.9373 71.8607C99.2133 74.5173 96.5672 76.1696 93.8623 75.6542L74.342 71.9345Z",
  fill: "#C4FFF3",
  stroke: "#141414",
  strokeWidth: 0.585938
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M84.8664 30.026L79.725 29.0297C76.6871 28.441 73.7976 30.5824 73.4768 33.6601L70.0843 66.2075C69.8002 68.9328 71.6506 71.4216 74.3422 71.9345L93.8625 75.6542C95.0237 75.8754 96.1741 75.6972 97.1662 75.2115L84.8664 30.026Z",
  fill: "black",
  fillOpacity: 0.23
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M52.9536 92.6709L42.3688 53.4668C41.4646 50.1176 43.6245 46.7132 47.0397 46.1045L78.1111 40.5665C81.4979 39.9629 84.683 42.3668 85.0311 45.7894L89.1275 86.0709C89.4398 89.1416 87.3376 91.9359 84.3007 92.4869L59.7176 96.9475C56.6942 97.496 53.7545 95.6374 52.9536 92.6709Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M55.7859 95.6257C53.0906 96.114 50.4701 94.4575 49.7551 91.8132L38.8584 51.514C38.0504 48.526 39.9776 45.488 43.025 44.9456L75.3992 39.1841C78.4191 38.6467 81.2587 40.7901 81.5695 43.8416L85.7866 85.2472C86.0656 87.9867 84.1899 90.4796 81.4804 90.9705L55.7859 95.6257Z",
  fill: "#418D85",
  fillOpacity: 0.24
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M59.0885 97.0917C56.394 97.5794 53.7744 95.9236 53.059 93.2803L42.083 52.7268C41.2741 49.7382 43.2018 46.699 46.2502 46.1571L78.8845 40.3548C81.9039 39.818 84.7428 41.961 85.0539 45.012L89.3016 86.6787C89.581 89.4187 87.7047 91.9121 84.9946 92.4027L59.0885 97.0917Z",
  stroke: "#141414",
  strokeWidth: 0.585938
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M51.2037 57.6991C50.8189 57.4759 50.326 57.6069 50.1028 57.9917C49.8796 58.3765 50.0106 58.8694 50.3954 59.0926L54.6388 61.5539L52.1775 65.7973C51.9543 66.1821 52.0853 66.6749 52.4701 66.8981C52.8549 67.1213 53.3477 66.9903 53.5709 66.6055L56.0323 62.3622L60.2756 64.8235C60.6604 65.0467 61.1533 64.9157 61.3765 64.5309C61.5997 64.1461 61.4687 63.6532 61.0839 63.43L56.8405 60.9687L59.3018 56.7253C59.525 56.3405 59.394 55.8477 59.0092 55.6245C58.6245 55.4013 58.1316 55.5323 57.9084 55.9171L55.4471 60.1605L51.2037 57.6991Z",
  fill: "#141414"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M65.3485 58.6282C65.2531 58.1306 65.5791 57.6498 66.0767 57.5543L78.9003 55.0947C79.3979 54.9993 79.8787 55.3253 79.9742 55.823C80.0696 56.3206 79.7436 56.8014 79.2459 56.8969L66.4224 59.3565C65.9248 59.4519 65.444 59.1259 65.3485 58.6282Z",
  fill: "#141414"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M86.9121 43.0674C100.73 49.5615 128.093 68.9515 132.762 93.6045C140.086 132.276 95.9941 138.868 58.9336 115.724",
  stroke: "white",
  strokeWidth: 0.585938
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M86.9121 42.4814C100.73 48.9756 128.093 68.3655 132.762 93.0186C140.086 131.69 95.9941 138.282 58.9336 115.138",
  stroke: "#141414",
  strokeWidth: 0.585938
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M62.4493 34.4249C51.7559 27.2472 28.963 15.3234 23.338 25.0499C16.3067 37.2081 46.7755 63.1359 30.3692 66.3586C17.2442 68.9367 25.7793 78.9562 31.6875 83.6437",
  stroke: "#141414",
  strokeWidth: 0.585938
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M44.9605 109.68C44.7287 109.04 45.0897 108.338 45.7453 108.153L47.9157 107.543C48.5388 107.368 49.1858 107.732 49.3609 108.355L52.083 118.041C52.2772 118.732 51.8103 119.433 51.0979 119.521L49.5598 119.71C49.0174 119.777 48.5008 119.46 48.3148 118.946L44.9605 109.68Z",
  fill: "#75FACF",
  fillOpacity: 0.5,
  stroke: "#141414",
  strokeWidth: 0.585938,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M69.9165 77.322C69.406 74.5259 65.9852 73.4272 63.9419 75.403L51.8234 87.1215C50.8133 88.0983 49.5366 88.7542 48.1543 89.0066L43.2726 89.8981C39.4057 90.6042 36.8434 94.3114 37.5495 98.1782L38.828 105.18C39.5342 109.047 43.2413 111.609 47.1082 110.903L51.9899 110.012C53.3722 109.759 54.7983 109.922 56.0885 110.478L71.5666 117.157C74.1763 118.284 76.988 116.047 76.4774 113.251L69.9165 77.322Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M67.3608 79.645C66.7942 76.9122 63.4457 75.8654 61.4235 77.7889L51.3362 87.3839C50.2576 88.4098 48.8844 89.0718 47.4099 89.2766L43.6223 89.8026C39.5102 90.3737 36.7577 94.3286 37.6505 98.383L38.3804 101.698C39.1933 105.389 42.7498 107.801 46.4801 107.191L49.3934 106.715C50.7359 106.495 52.1132 106.665 53.3622 107.204L68.7274 113.834C71.3724 114.976 74.2068 112.665 73.622 109.844L67.3608 79.645Z",
  fill: "#F4FFB5"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M82.6478 103.86C83.3341 100.543 83.4061 97.0411 82.7601 93.504C82.1142 89.9668 80.8092 86.7162 78.9948 83.8557",
  stroke: "white",
  strokeWidth: 1.46484,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M83.8197 103.274C84.506 99.9573 84.5779 96.4552 83.932 92.918C83.2861 89.3809 81.9811 86.1302 80.1667 83.2697",
  stroke: "#141414",
  strokeWidth: 1.46484,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M89.31 112.979C90.6826 106.345 90.8265 99.3411 89.5347 92.2667C88.2429 85.1924 85.6328 78.6912 82.004 72.9701",
  stroke: "white",
  strokeWidth: 1.46484,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M90.4819 112.394C91.8544 105.759 91.9984 98.7551 90.7066 91.6808C89.4148 84.6065 86.8046 78.1052 83.1759 72.3842",
  stroke: "#141414",
  strokeWidth: 1.46484,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M43.2728 89.8976L40.1825 90.479C36.334 91.203 33.7933 94.8999 34.4967 98.7523L35.7752 105.754C36.484 109.635 40.2151 112.199 44.0927 111.47L47.1084 110.903M43.2728 89.8976L48.1545 89.0062C49.5368 88.7538 50.8135 88.0979 51.8236 87.1211L52.406 86.5579C59.3804 79.8137 71.0566 83.564 72.7994 93.108L73.5949 97.4639C75.3377 107.008 65.7404 114.643 56.8326 110.799L56.0887 110.478C54.7985 109.921 53.3724 109.759 51.9901 110.011L47.1084 110.903M43.2728 89.8976L47.1084 110.903",
  stroke: "#141414",
  strokeWidth: 0.585938,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 84.9447,
  cy: 134.163,
  r: 2.91348,
  fill: "#C4FFF3"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 128.813,
  cy: 69.3406,
  r: 1.66485,
  stroke: "#141414",
  strokeWidth: 0.585938
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 28.9109,
  cy: 28.032,
  r: 1.66485,
  stroke: "#141414",
  strokeWidth: 0.585938
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 79.8905,
  cy: 22.5889,
  r: 2.08106,
  stroke: "#141414",
  strokeWidth: 0.585938
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M105.491 91.6992L101.953 94.8208L105.699 98.5667L108.404 95.8613L105.491 91.6992Z",
  fill: "#F8FFD3",
  stroke: "#141414",
  strokeWidth: 0.585938
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M16.39 78.8146L13.4765 74.2362L17.8467 72.3633L19.5116 76.7335L16.39 78.8146Z",
  fill: "#FAC6D4"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M29.8828 118.05L35.5016 115.137",
  stroke: "#141414",
  strokeWidth: 0.585938
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M108.609 32.3697L112.771 26.959",
  stroke: "#141414",
  strokeWidth: 0.585938
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M103.693 30.2142L102.872 23.4374",
  stroke: "#141414",
  strokeWidth: 0.585938
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M112.707 40.2305L118.289 39.7415",
  stroke: "#141414",
  strokeWidth: 0.585938
});

function SvgSurveynone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveynone);
export default __webpack_public_path__ + "static/media/surveynone.d85ec139.svg";
export { ForwardRef as ReactComponent };